<div class="form-field" [ngClass]="containerClass">
  <p class="m-b-0">
    @if (labelTooltip) {
      {{ label }}<shared-info-icon [tooltip]="labelTooltip" />
    } @else {
      {{ label }}
    }
  </p>

  <div class="field-content" [ngClass]="contentClass">
    @if (disabled) {
      <span class="disabled-text">{{ control?.value || 'N/A' }}</span>
    } @else {
      <ng-content></ng-content>
    }

    @if (isFieldInvalid()) {
      @if (control.errors?.required) {
        <mat-error>{{ label }} is required</mat-error>
      }
      @if (control.errors?.whitespace) {
        <mat-error>{{ label }} cannot be empty or contain only whitespace</mat-error>
      }
      @if (control.errors?.min) {
        <mat-error>Minimum value is {{ control.errors?.min.min }}</mat-error>
      }
      @if (control.errors?.max) {
        <mat-error>Maximum value is {{ control.errors?.max.max }}</mat-error>
      }
      @if (control.errors?.email) {
        <mat-error>Invalid email address</mat-error>
      }
      @if (control.errors?.days) {
        <mat-error>Invalid days format. Use comma-separated values between -31 and 31, excluding zero.</mat-error>
      }
      @if (control.errors?.timeWindow) {
        <mat-error>Start time must be earlier than end time</mat-error>
      }
      @if (control.errors?.pattern) {
        <mat-error>Invalid format</mat-error>
      }
    }
  </div>
</div>
